var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',[_vm._v(" "+_vm._s(_vm.$t('widgeterSettingsIntegrations.title'))+" ")]),_c('div',{staticClass:"item-list"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('IntegrationsItem',{attrs:{"item":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }